<template>
  <PanelRow>
    <Panel>
      <h2 slot="header">{{ 'titles.reports' | trans }}</h2>
      <div class="center">
        <button type="button" class="btn xl" @click="generate">
          <i class="icon">+</i>
          {{ 'loyaltyvenue:reports.generate.title' | trans }}
        </button>
      </div>
      <List class="admin-reports-list" v-if="list" :fields=fields :items="list" @clicked="download" />
      <Loading v-if="!items" />
    </Panel>
  </PanelRow>
</template>

<script>
  import List from '@/helpers/components/display/List'
  import Wizard from '@/helpers/components/display/Wizard'
  import Recordset from '@/providers/api/Recordset'
  import ModalDialogs from 'vue-modal-dialogs'
  import {list as mixin} from '@/helpers/mixins/pagination'
  import form from '@/helpers/mixins/form'
  import {reports as fields} from '@/apps/loyaltyvenue/fields'
  import {format as dateformat, getDaysInMonth} from 'date-fns'
  import _ from 'lodash'

  // Make a dialog function
  const generate = ModalDialogs.makeDialog({
    mixins: [form],
    components: {Wizard},
    data () {
      var protofields = _.pick(fields, ['reports_types_id', 'extension', 'description']);
      if (protofields.reports_types_id) {
        protofields.reports_types_id.getValues = r => r
          .filter(d => d.admin)
          .map(r => ({
            id: r.id,
            name: r.name,
          }))
        ;
      }
      return {
        protofields,
        item: {},
        valid: false,
        loading: false,
      };
    },
    template:
      '<Wizard class=message :logo=false>\
        <h3>{{ "loyaltyvenue:reports.generate.title" | trans }}</h3>\
        <a class="close" v-close @click="$close(false)"></a>\
        <VueForm v-if="formReady" :options=formOptions :schema=schema :model=item @validated=validated />\
        <a class="btn inverse" @click="$close(false)">{{ "buttons.close" | trans }}</a>\
        <a class="btn" :disabled="!valid" @click="submit">{{ "buttons.submit" | trans }}</a>\
        <Loading v-if="loading" class="absolute" />\
      </Wizard>',
    methods: {
      validated (valid) {
        this.valid = valid;
      },
      submit () {
        if (this.valid) {
          this.loading = true;
          this.async('user')
            .then(user => this.api.get('apptokens?filter=users_id::eq::' + user.id + '&range=single'))
            .then(token => {
              var data = {
                apptokens_id: token.id,
                apptokens_apps_id: token.id,
                reports_types_id: this.item.reports_types_id,
                description: this.item.description,
                extension: this.item.extension,
              };
              return this.api.post('reports', data);
            })
            .toast(false, this.$t('loyaltyvenue:reports.generate.error'))
            .then((result) => {
              if (result.resource_id) {
                document.toast(
                  this.$t('loyaltyvenue:reports.generate.immediate'),
                  'success'
                );
                this.$close(true);
              } else {
                document.toast(
                  this.$t('loyaltyvenue:reports.generate.success'),
                  'info'
                );
                this.$close(false);
              }
            })
            .finally(() => this.loading = false)
          ;
        }
      },
    },
  })

  export default {
    name: 'Reports',
    mixins: [mixin],
    components: {List},
    data () {return {
      fields: _.pick(fields, ['id', 'name', 'extension', 'description', 'created_at']),
      reloadcount: 1,
    }},
    asyncComputed: {
      applicable_types: {
        get () {
          return this.api
            .get('reports_types?filter=admin::eq::1&range=all')
            .then(r => r.list)
          ;
        },
        default: [],
      },
      items: {
        get () {
          //get apptoken
          return Promise.all(this.applicable_types
              .map(type => this.api.get(
                'reports?filter=reports_types_id::eq::' + type.id + '&range=0,200'
              ))
            )
            //union reports recordsets
            .then(reportlists =>
              reportlists.reduce(
                (union, current) => union.union(current),
                new Recordset('reports')
              )
            )
            //sort by id DESC, get list
            .then(reports => reports.sort('id', true).list)
          ;
        },
        default: [],
        watch () {
          this.applicable_types && this.reloadcount;
        },
      },
    },
    methods: {
      generate () {
        return generate().then(submitted => {
          if (submitted) {
            this.reloadcount++;
            this.p = 1;
          }
        });
      },
      download (report) {
        return this.api.download('get', 'reports/download/' + report.id);
      }
    }
  }
</script>

<style lang="scss">
  .admin-reports-list {
    margin-top: 60px;
    table tbody tr {
      cursor: pointer;
    }
  }

  .th-extension, .td-extension {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/sections/general/AdminReports.vue